/**
 * Represents an email address.
 */
export class Email {
  private email: string;
  private domain: string;

  /**
   * Creates an instance of the Email class.
   * @param email - The email address.
   * @throws {Error} If the email is empty or invalid.
   */
  constructor(email: string) {
    if (!email) {
      throw new Error("Email cannot be empty");
    }

    this.email = email;
    const split = this.email.split("@");
    if (split.length != 2) {
      throw new Error("Invalid email");
    }

    this.domain = split[1];
  }

  /**
   * Gets the domain of the email address.
   * @returns The domain of the email address.
   */
  getDomain() {
    return this.domain;
  }

  /**
   * Gets the email address.
   * @returns The email address.
   */
  getEmail() {
    return this.email;
  }
}
